import {
  Channel,
  ChannelHeader,
  MessageInput,
  MessageList,
  Thread,
  useChatContext,
  Window
} from "stream-chat-react";
import { Applicant } from "types/application";

export const ApplicantChatSlice = ({
  applicant,
  canWriteMessage = true
}: {
  applicant: Applicant;
  canWriteMessage?: boolean;
}) => {
  const { setActiveChannel, client } = useChatContext();
  // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition -- need it here
  const channel = client?.getChannelById(
    "messaging",
    "chat-id-" + applicant.id,
    {
      watch: true
    }
  );

  // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition -- lib types are bs
  setActiveChannel?.(channel);

  return (
    <div className="flex flex-col h-full md:max-h-[calc(100vh-400px)]">
      <div className="md:flex md:h-[calc(100vh-400px)]">
        {/* eslint-disable-next-line @typescript-eslint/no-unnecessary-condition -- lib types are unreliable */}
        {channel ? (
          <Channel channel={channel}>
            <Window>
              <ChannelHeader />
              <MessageList />
              <div className="h-px bg-alpha-40" />
              {canWriteMessage ? (
                <MessageInput />
              ) : (
                <p className="text-sm text-content-500">
                  Cannot send messages to this applicant
                </p>
              )}
            </Window>
            <Thread />
          </Channel>
        ) : (
          <p>No chat found</p>
        )}
      </div>
    </div>
  );
};
